<template>
  <div :class="['px-12', contentColumnClass]">
    <MainContent paddingClass="py-6 px-6">
      <AppointmentTitle v-if="showAppointmentTitle" />

      <div>
        <router-view />
      </div>
    </MainContent>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import AppointmentTitle from '@/components/checkout/appointmentTitle.vue';
import MainContent from '@/components/design/mainContent.vue';

export default defineComponent({
  name: 'CheckoutLeftPane',
  components: {
    AppointmentTitle,
    MainContent,
  },
  props: {
    showAppointmentTitle: {
      type: Boolean,
      default: true,
    },
    contentColumnClass: {
      type: String,
      default: 'xl:w-full',
    },
  },
});
</script>
